import { navigationWeb, useSelector } from 'gf-ui';
import React, { useEffect, useRef } from 'react';
import { FaHome } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { API_SERVICES } from '..';
import QHome from '../../libQuestionario/pages/QHome';
import PDTAHeader from './components/PDTAHeader';

const PDTAHome = () => {  
  const pageData = useSelector( state => state.page.data )
  const dispatch = useDispatch()
  const shouldInit = useRef(true) 
  
  useEffect(()=>{
    if(shouldInit.current){
      shouldInit.current = false
      navigationWeb(dispatch, [
        { label: "Home", icon: <FaHome />, route: "/", active: "/" }
      ] )
    }
  }, [dispatch])

  return <><QHome homeRoute={ API_SERVICES.PDTA.HOME_ROUTE }
                root={ API_SERVICES.PDTA.ROOT } 
                title={ API_SERVICES.PDTA.NOME }
                headerComponent={<PDTAHeader label={pageData.SERVIZI_ABILITATI.find( s => s.CODICE === API_SERVICES.PDTA.CODICE ).DESCRIZIONE } />}                 
                /> 
                </>
}
export default PDTAHome;